import { logCoreUsage } from 'owa-analytics';
import type { MailboxInfo } from 'owa-client-types';
import { getSeedStatus } from 'owa-copilot-async-chat';
import getEntriesBySection from '../selectors/getEntriesBySection';
import { TasksHubSection } from './TasksHubSection';

export type TasksHubViewSource = 'drawerHeaderMenu' | 'dabViewAll';

/**
 * Logs the backlog state the user lands on when the Tasks Hub is opened.
 */
export function logTasksHubViewed(mailboxInfo: MailboxInfo, source: TasksHubViewSource): void {
    const sections = getEntriesBySection(mailboxInfo);
    const needsAttentionCount = sections[TasksHubSection.NeedsAttention].length;
    const inProgressCount = sections[TasksHubSection.InProgress].length;
    const readyToReviewCount = sections[TasksHubSection.ReadyToReview].length;
    logCoreUsage('AsyncChat_TasksHubViewed', mailboxInfo, {
        source,
        needsAttentionCount,
        inProgressCount,
        readyToReviewCount,
        total: needsAttentionCount + inProgressCount + readyToReviewCount,
        seedStatus: getSeedStatus(mailboxInfo),
    });
}
